import {getRedCount} from "@/api/redCount";
import store from "@/store";
function nakedApproveRedNum() {
    return {
        total : 0,
        pending : 0,
        fail : 0,
        computeTotal() {
            this.total = this.pending + this.fail
        },
        empty() {
            this.total = 0
            this.pending = 0
            this.fail = 0
        }
    }
}
const state = {
    showLeftMenu: true,//控制侧边栏的折叠与展开
    reportRedDoltNum: 0,
    nakedReportRedDoltNum: new nakedApproveRedNum(),
    nakedDataReleaseRedDoltNum: new nakedApproveRedNum(),
}
const getters = {
    getShowLeftMenu: (state) => {
        return state.showLeftMenu
    },
    getAllApprovalRedDoltNum(){
       return  state.nakedReportRedDoltNum.total+state.nakedDataReleaseRedDoltNum.total
    },
    getNakedReportRedDoltNum: (state) => {
        state.nakedReportRedDoltNum.computeTotal()
        return state.nakedReportRedDoltNum
    },
    getNakedDataReleaseRedDoltNum: (state) => {
        state.nakedDataReleaseRedDoltNum.computeTotal()
        return state.nakedDataReleaseRedDoltNum
    },
    getReportRedDoltNum: (state) => {
        return state.reportRedDoltNum
    },

}
const mutations = {
    setInit(state){
        state.nakedRedDoltNum.empty()
        state.reportRedDoltNum=0
    },
    setShowLeftMenu: (state,data) => {
        if (data==='setShowLeftMenu'){
            state.showLeftMenu = true
        }else {
            state.showLeftMenu = !state.showLeftMenu
        }
    },
    setNakedReportRedDoltNum(state, data) {
        state.nakedReportRedDoltNum[data.type] = data.num
    },
    setNakedDataReleaseRedDoltNum(state, data) {
        state.nakedDataReleaseRedDoltNum[data.type] = data.num
    },
    setReportRedDoltNum(state, data) {
        if (!data.type) {
            state.reportRedDoltNum = data.num
        }

    },
}
const actions = {
    //获取报告、裸测未审批条数
    async getRedDoltNum({commit}, info) {
        if(['ADMIN','MANAGER'].includes(store.getters["right/getRole"])||store.getters["right/getUser"][info.viewer.content]){
            const res = await getRedCount(info.data, info.sys)
            if (res.code === 200) {
                commit(info.setRedDoltName, {num: parseInt(res.data), type: info.type})
            }
        }

    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
